export default "__VITE_ASSET__CtH8N5Va__"